import Amplify from "@aws-amplify/core";
import jwt_decode from 'jwt-decode';
import Auth from "@aws-amplify/auth";
import CONFIG from "../config";
import UrlSearchParams from '.';

export const googleSignIn = async () => {
  
  const code = UrlSearchParams('code');
  if(code){
      const codePayload = {
        grant_type: "authorization_code",
        code,
        client_id: CONFIG.cognito.APP_CLIENT_ID,
        redirect_uri: CONFIG.cognito.REDIRECT_URI,
      };

      const tokenResponse = await getCognitoToken(codePayload);
      const { id_token, refresh_token, expires_in } = tokenResponse;
      localStorage.setItem('COGNITO:RefreshToken',refresh_token);
      const token_res = jwt_decode(id_token);
     
      let user = {
          email: token_res.email,
          name: token_res.name,
          profilePic: token_res.picture,
          googleId: token_res["cognito:username"],
          loginType: 'gmail'
      };
      
      const authDetails = await Auth.federatedSignIn(
        CONFIG.cognito.IDP,
        {
            token: id_token,
            expires_at: expires_in * 1000 + new Date().getTime()
        },
        user
      )

      if(authDetails){
        const identity = token_res.identities[0];
        let signupTime = new Date(Number(identity.dateCreated));
        return Promise.resolve({
          ...authDetails,
          ...user,
          signupTime
        })
      }
      else{
        return Promise.reject();
      }
  }

  return Promise.reject('Not Signed In');
}

export const cognitoLogout = () => {
  localStorage.clear();
  Auth.signOut()
  .then(data =>{ 
      window.location.href = CONFIG.cognito.IDP;
  })
  .catch(err => console.log(err));
}

const getCognitoToken = async (codePayload) => {

  const searchParams = Object.keys(codePayload).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(codePayload[key]);
  }).join('&');

  const response = await fetch(`https://${CONFIG.cognito.DOMAIN}/oauth2/token`,{
    method: 'POST',
    headers: {
      'Content-Type':'application/x-www-form-urlencoded'
    },
    body: searchParams
  });

  const tokenResponse = await response.json();
  return tokenResponse;
}

const refreshToken = async () => {
  
  const codePayload = {
    grant_type: "refresh_token",
    client_id: CONFIG.cognito.APP_CLIENT_ID,
    refresh_token: localStorage.getItem('COGNITO:RefreshToken')
  };
  const tokenResponse = await getCognitoToken(codePayload);
  const { id_token, expires_in } = tokenResponse;
  
  return new Promise((res, rej) => {
      const data = {
        token: id_token,
        expires_at: expires_in * 1000 + new Date().getTime()
      }
      res(data);
  });
}

const configCognito = () => {
  Amplify.configure({
    Auth: {
      identityPoolId: CONFIG.cognito.IDENTITY_POOL_ID,
      region: CONFIG.cognito.REGION,
      userPoolId: CONFIG.cognito.USER_POOL_ID,
      userPoolWebClientId: CONFIG.cognito.APP_CLIENT_ID,
    },
    refreshHandlers: {
      'cognito-idp.ap-south-1.amazonaws.com': refreshToken,
    },
  })
}

export default configCognito;